var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8986 1.81577C13.0471 1.66736 13.2484 1.58398 13.4583 1.58398C13.6683 1.58398 13.8696 1.66736 14.018 1.81577L17.1847 4.98244C17.3331 5.1309 17.4165 5.33223 17.4165 5.54215C17.4165 5.75207 17.3331 5.9534 17.1847 6.10186L6.89304 16.3935C6.74461 16.542 6.54328 16.6254 6.33333 16.6255H3.16667C2.9567 16.6255 2.75534 16.5421 2.60687 16.3936C2.45841 16.2451 2.375 16.0438 2.375 15.8338V12.6671C2.37504 12.4572 2.45848 12.2559 2.60696 12.1074L10.5236 4.19077L12.8986 1.81577ZM11.0833 5.8699L3.95833 12.9949V15.0421H6.00558L13.1306 7.91715L11.0833 5.8699ZM14.25 6.79773L15.5056 5.54215L13.4583 3.4949L12.2027 4.75048L14.25 6.79773Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.c879ec31122360e12d7cc92c871dd45b.svg";
export { ForwardRef as ReactComponent };